import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faHeart, faLink, faToolbox, faBriefcase, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../styles/TemplateOne.css';

const TemplateOne = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    // console.log("template...............................",template)


    const skillsWithLevels = Array.isArray(template?.skills) ? template?.skills.map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 51) + 50 // Random level between 50 and 100
    })) : [];


    return (
        <div className="template-one" onClick={() => onClick(template.id)}>
            <div className="content-wrapper">
                <div className="sidebar">
                    {template?.image && template?.image.length > 0 && (
                        <div className="image-section">
                            <img src={template?.image} alt={template?.name} className="template-image" />
                        </div>
                    )}
                    {template?.name && <h1 className="template-one-name" style={{ color: 'white' }}>{template?.name}</h1>}

                    {template?.contact && (
                        <div className="template-contact">
                            <h3>Contact</h3>
                            {template?.contact?.phone && <p><FontAwesomeIcon icon={faPhone} /> {template?.contact.phone}</p>}
                            {template?.contact?.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template?.contact.email}</p>}
                            {template?.contact?.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template?.contact.address}</p>}
                        </div>
                    )}

                    {template?.languages && template?.languages.length > 0 && (
                        <div className="template-languages">
                            <strong><FontAwesomeIcon icon={faLanguage} /> Languages:</strong> {template?.languages.join(', ')}
                        </div>
                    )}
                    {template?.hobbies && template?.hobbies.length > 0 && (
                        <div className="template-hobbies">
                            <strong><FontAwesomeIcon icon={faHeart} /> Hobbies:</strong> {template?.hobbies.join(', ')}
                        </div>
                    )}

                    {template?.links && template?.links.length > 0 && (
                        <div className="template-links">
                            <strong>Links:</strong>
                            {template.links.map(([key, value]) => (
                                <p key={key}>
                                    <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer">{linkText[key]}</a>
                                </p>
                            ))}
                        </div>
                    )}

                </div>
                <div className="main-content">

                    <div className="template-about template-section">
                        <h2>About Me</h2>
                        {template?.aboutMe && <p className="template-about">{template?.aboutMe}</p>}
                    </div>

                    {template?.skills && template?.skills.length > 0 && (
                        <div className="template-skills template-section">
                            <h2>Skills</h2>
                            <div className="skills-wrapper">
                                {skillsWithLevels.map((skill, index) => (
                                    <div key={index} className="skill-item">
                                        <span className="skill-name">{skill.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {template?.softwareSkills && (
                        <div className="template-skills template-section">
                            <h2>Software Skills</h2>
                            <div className="skills-wrapper">
                                {skillsWithLevels.map((skill, index) => (
                                    <div key={index} className="skill-item">
                                        <span className="skill-name">{skill.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {template?.workExperience && template?.workExperience.length > 0 && (
                        <div className="template-work-experience template-section">
                            <h2>Work Experience</h2>
                            {template?.workExperience.map((experience, index) => (
                                <div key={index} className="work-experience-item">
                                    {experience.role && <p className="role">{experience.role} at {experience.company}</p>}
                                    {experience.location && (
                                        <p className="location">
                                            (
                                            {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                    )}
                                    {experience.description && <p className="description">{experience.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                    {template?.education && Array.isArray(template?.education) && template?.education.length > 0 && (
                        <div className="template-education template-section">
                            <h2>Education</h2>
                            {template?.education.map((edu, index) => (
                                <div key={index} className="education-item">
                                    {edu.degree && <p className="degree">{edu.degree} from {edu.institution}</p>}
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    {edu.description && <p className="description">{edu.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.certificates && template?.certificates.length > 0 && (
                        <div className="template-education template-section">
                            <h2 >Certificates</h2>
                            {template?.certificates?.map((certificate, index) => (
                                <div key={index} className="education-item degree">
                                    <p className="degree">Title: {certificate.title}</p>
                                    <p className="institution">Institution: {certificate.institution}</p>
                                    <p className='institution'>
                                        Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default TemplateOne;
